import React, { useEffect } from "react";
import {
  setAllActiveAssets,
  setAllActiveAssetsLoader,
} from "../../../../infra/aggregates/myProfile/AssetsAggregates/activeAssetsSlice";
import { useAppDispatch, useAppSelector } from "../../../../infra/hooks";
import { assetsService } from "../../../../api/services/assetsService";
interface PropsValues {
  setassignedassetData: (data: any) => void;
}
function DTOActiveAssets({ setassignedassetData }: PropsValues) {
  const dispatch = useAppDispatch();
  const selector = useAppSelector((state) => state.authSlice);
  const storeActiveAssets = useAppSelector(
    (state) => state.activeAssetsSlice.activeAssets
  );
  async function getAllActiveAssets(empId: number, companyId: number) {
    dispatch(setAllActiveAssetsLoader(true));
    const response = await assetsService.getActiveAssets(empId, companyId);
    if (response) {
      dispatch(setAllActiveAssets(response?.data));
      setassignedassetData(response?.data);
      dispatch(setAllActiveAssetsLoader(false));
    } else {
      dispatch(setAllActiveAssetsLoader(false));

      return;
    }
  }
  useEffect(() => {
    if ((selector.emp_id, selector.company_id))
      getAllActiveAssets(selector.emp_id, selector.company_id);
  }, []);

  useEffect(() => {
    setassignedassetData(storeActiveAssets);
  }, [storeActiveAssets]);
  return <></>;
}

export default DTOActiveAssets;
